import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/TicketTLO/ResultsData";

const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) => {
  let updatedItemsList = action.data
  switch (action.type) {
    case ActionType.TICKET_TLO_DATA_FETCHED:
      return { ...state, items: updatedItemsList };
    default:
      return state;
  }
};

export default updateResultsData;
